module.exports = __webpack_public_path__ + "static/media/4.Column Pipes.46b1be8b.jpg";